import { render } from "./ArchiveContracts.vue?vue&type=template&id=d1574590&scoped=true"
import script from "./ArchiveContracts.vue?vue&type=script&lang=js"
export * from "./ArchiveContracts.vue?vue&type=script&lang=js"

import "./ArchiveContracts.vue?vue&type=style&index=0&id=d1574590&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1574590"]])

export default __exports__